var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27 1.07a.56.56 0 0 0-.543 0L1.411 4.002A.797.797 0 0 0 1.798 5.5h10.404a.799.799 0 0 0 .387-1.498zm-.92 3.305H3.066l3.933-2.17 3.933 2.17H7.648a.75.75 0 1 0-1.298 0M2.499 6.25V10a.56.56 0 0 0-.563.563c0 .311.251.562.563.562h9.187a.561.561 0 1 0 0-1.125H11.5V6.25h-1.125V10h-1.5V6.25H7.749V10h-1.5V6.25H5.124V10h-1.5V6.25zm-.75 5.625a.56.56 0 0 0-.563.563c0 .311.251.562.563.562h10.687a.561.561 0 1 0 0-1.125z"
  })));
};
export default SvgBank;